// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"0":"05dd9b1e","46":"460db57f","290":"6e3017d9","294":"252c90a9","361":"e458a414","384":"3c53ffea","417":"d3e8a105","479":"84afe14a","640":"b4f1c81f","722":"bded2af6","873":"730f20d1","916":"ccad228d","953":"fe08d8a9"}[chunkId] + ".chunk.js";
};